import { useQuery } from '@tanstack/react-query'

import { api } from '../../api/client'

/** Пока операция ждёт подписи, статус меняется с телефона — опрашиваем раз в 5 секунд (ФТ-22). */
const LIVE = 5_000

/** Операции подписания: `assigned` — ждут моей подписи, `initiated` — отправленные мной. */
export function useSigningOperations(scope: 'assigned' | 'initiated') {
  return useQuery({
    queryKey: ['signing-operations', scope],
    queryFn: () => api.signingOperations(scope),
    refetchInterval: LIVE,
  })
}

/**
 * Карточка операции. Пока она открыта, человек держит экран с QR и подписывает в приложении —
 * опрашиваем, чтобы «Подписан» появился без перезагрузки. Завершённую больше не дёргаем.
 */
export function useSigningOperation(id: string | null) {
  return useQuery({
    queryKey: ['signing-operation', id],
    queryFn: () => api.signingOperation(id as string),
    enabled: Boolean(id),
    retry: false,
    refetchInterval: (query) => {
      const status = query.state.data?.status
      return status === 'created' || status === 'data_served' ? LIVE : false
    },
  })
}
